// src/components/RouteTracker.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "../context/cookieConsent";

const GA_MEASUREMENT_ID = "G-DLMV5GKLE0"; // <-- your ID

export const RouteTracker = () => {
  console.log("RouteTracker rendered");
  const location = useLocation();
  const { consentGiven } = useConsent();

  useEffect(() => {
    if (!consentGiven || typeof window === "undefined" || !window.gtag) return;

    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location, consentGiven]);

  return null; // renders nothing
};
